import { createAction } from '@ngrx/store';

export const setLineageMainSearchValue = createAction('[LINEAGE] Set main search value', (payload) => ({payload}));
export const setLineageByTypeSearchValue = createAction('[LINEAGE] Set search value by type', (payload) => ({payload}));
